import { Modal as VcdkModal } from '@volvo/vcdk-react';
import { useEffect, useRef, type ComponentProps } from 'react';

// SAFETY: vcdk-modal ships a focus trap but never arms it (no focusFirstElement on open,
// sentinels stay tabindex=-1). Delete this shim when @volvo/vcdk fixes modal focus upstream.
const AppModal = ({ children, ...props }: ComponentProps<typeof VcdkModal>) => {
  const ref = useRef<VcdkModal.Element>(null);

  useEffect(() => {
    const modal = ref.current;
    if (!modal || !props.open) return;
    const previouslyFocused = document.activeElement;
    void modal.updateComplete.then(() => {
      modal.shadowRoot?.querySelector('[role="dialog"]')?.setAttribute('aria-modal', 'true');
      modal.shadowRoot?.querySelector('vcdk-focus-trap')?.focusFirstElement();
    });
    return () => {
      if (previouslyFocused instanceof HTMLElement && previouslyFocused.isConnected) {
        previouslyFocused.focus();
      }
    };
  }, [props.open]);

  return (
    <VcdkModal ref={ref} {...props}>
      {children}
    </VcdkModal>
  );
};

export default AppModal;
